import React, { useEffect, useState } from "react";
import TableContainer from "../TableContainer";
import { useDispatch } from "react-redux";
import { getApprovalTugasTambahan } from "../../store/actions/actionApproval";
import { AppThunkDispatch, useAppSelector } from "../../store";
import FormApproval from "../forms/FormApproval";

function TableApprovalTambahan() {
  const [isApproval, setIsApproval] = useState(false);
  const [dataToUpdate, setDataToUpdate] = useState<any>({});

  const dispatch = useDispatch<AppThunkDispatch>();
  const { approvalTugasTambahan } = useAppSelector((state) => state.approval);

  useEffect(() => {
    dispatch(getApprovalTugasTambahan());
  }, []);
  return (
    <div>
      <FormApproval
        show={isApproval}
        oneData={dataToUpdate}
        onClose={() => {
          setIsApproval(false);
          setDataToUpdate({});
        }}
      />
      <TableContainer tableTitle="Tugas Tambahan">
        <table className="table">
          <thead className="thead">
            <tr>
              <th className="th">Nama</th>
              <th className="th">status</th>
              <th className="th">Pegawai</th>
              <th className="th">Action</th>
            </tr>
          </thead>
          <tbody className="tbody">
            {approvalTugasTambahan.map((d, i) => (
              <tr className="tr" key={i}>
                <td className="td">{d.listTugasTambahan.nama_tugasTambahan}</td>
                <td className="td">
                  {d.status === true ? "Disetujui" : "Belum disetujui"}
                </td>
                <td className="td">{d.ptk.nama}</td>
                <td className="td">
                  <button
                    className="btn"
                    onClick={() => {
                      setIsApproval(true);
                      setDataToUpdate(d);
                    }}
                  >
                    Tanggapi
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </TableContainer>
    </div>
  );
}

export default TableApprovalTambahan;
